module.exports = __webpack_public_path__ + "img/table.314f246b.png";